import { common as c, operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

export default {
    name: 'app-metrics-hover',
    productArea: PRODUCT_AREAS.ASK_PENDO,
    subProductArea: SUB_PRODUCT_AREAS.LEO_HOVER_CARDS,
    responseFormat: 'row',
    build: ({
        id,
        timeSeries,
        includeAnonymous,
    }: {
        id: string;
        timeSeries: c.TimeSeries;
        includeAnonymous?: string | boolean | null;
    }) => {
        return o.pipeline(
            o.sources.events({
                appId: id,
                timeSeries,
            }),
            o.identified(includeAnonymous || undefined),
            o.reduce({
                uniqueVisitors: o.count('visitorId'),
                uniqueAccounts: o.countIf('accountId', 'accountId != ""'),
            }),
        );
    },
};
